import { Notification } from "rxjs";
import { tap } from "rxjs/operators";
export function materializeTap(next) {
    return (source) => source.pipe(tap({
        complete: () => next(new Notification("C")),
        error: (error) => next(new Notification("E", undefined, error)),
        next: (value) => next(new Notification("N", value)),
    }));
}
//# sourceMappingURL=materializeTap.js.map